import { UpdateData } from '@firebase/firestore';
import { IDog, IMilestone, IProfile, Month, TimelineNode } from '@jumpstart/core';
import { collection, doc, QuerySnapshot, DocumentReference, QueryDocumentSnapshot, Query, updateDoc } from 'firebase/firestore';
import moment from 'moment';
import React, { Context, createContext, ReactElement, useContext, useEffect } from 'react';
import { useCollection, useCollectionDataOnce, useDocumentData } from 'react-firebase-hooks/firestore';
import { db } from '../../../core/firebase';
import { IDailyMessage, ISubscriber } from '../schema';


export const dateStrToDate = (str: string): moment.Moment => {
  const m: moment.Moment = moment();
  const arr = str.split('_');
  const month = TimelineNode.monthIndex(arr[0] as Month);
  m.set({ month: month, date: parseInt(arr[1], 10), year: parseInt(arr[2], 100), hour: 10, minute: 5 });
  return m;
};

export interface ISubscriberProviderData {
  subscriber: ISubscriber | null;
  subscriberProfile: IProfile | null;
  dog: IDog | null;
  messages: IDailyMessage[];
  milestones: IMilestone[];
}

export interface ISubscriberProvider {
  subscriber: ISubscriber | null;

  children(props: ISubscriberProviderData): (ReactElement | null);
}

export const SubscriberContext: Context<ISubscriberProviderData> = createContext<ISubscriberProviderData>({
  dog: null,
  subscriberProfile: null,
  subscriber: null,
  messages: [],
  milestones: []
});

export const useSubscriber = () => useContext(SubscriberContext);

export default function SubscriberProvider(props: ISubscriberProvider) {
  const { subscriber, children } = props;

  const [profile] = useDocumentData<IProfile>(doc(db, 'scout9-profiles', subscriber ? subscriber.uid : 'UNKNOWN') as DocumentReference<IProfile>);
  const [dog] = useDocumentData<IDog>(doc(db, 'scout9-profiles', subscriber ? subscriber.uid : 'UNKNOWN', 'dogs', 'default') as DocumentReference<IDog>);
  const [messages] = useCollection(collection(db, 'scout9-messages', subscriber ? subscriber.phone : 'UNKNOWN', 'messages'));
  const [milestones] = useCollectionDataOnce<IMilestone>(collection(db, 'scout9-milestones') as Query<IMilestone>);

  useEffect(() => {
    if (profile && subscriber && profile.id === subscriber.uid) {
      const updates: UpdateData<IProfile> = {}
      if (subscriber.phone !== profile.phone) {
        console.log('Updating profile phone (was not included)');
        updates.phone = subscriber.phone;
      }
      if (subscriber.email && subscriber.email !== profile.email) {
        console.log('Updating profile email (was not included)');
        updates.email = subscriber.email;
      }
      if (Object.keys(updates).length > 0) {
        updateDoc(doc(db, `scout9-profiles/${subscriber.uid}`), updates)
          .then(() => {
            console.log('Profile updated');
          })
          .catch((err: Error) => {
            console.error('Update failed', err.message);
          });
      }
    }

  }, [profile]);
  const mapMessages = (q: QuerySnapshot): IDailyMessage[] => q.docs.map((doc: QueryDocumentSnapshot) => {
    return {
      ...doc.data() as IDailyMessage,
      date: dateStrToDate(doc.id).toISOString()
    };
  });
  return (
    <SubscriberContext.Provider value={{
      dog: !!dog ? dog : null,
      subscriberProfile: !!profile ? profile : null,
      subscriber: !!subscriber ? subscriber : null,
      messages: !!messages ? mapMessages(messages) : [],
      milestones: !!milestones ? milestones : []
    }}
    >
      {
        children({
          dog: dog ? dog : null,
          subscriberProfile: profile ? profile : null,
          subscriber: !!subscriber ? subscriber : null,
          messages: !!messages ? mapMessages(messages) : [],
          milestones: !!milestones ? milestones : []
        })
      }
    </SubscriberContext.Provider>
  );
}
